import React from 'react';

/**
 * Simple tabs for Photos / Videos toggle.
 *
 * Props:
 *   activeTab    – 'photos' | 'videos'
 *   onChange     – (tab) => void
 *   photoCount   – number
 *   videoCount   – number
 */
export default function MediaTabs({ activeTab, onChange, photoCount = 0, videoCount = 0 }) {
  return (
    <div className="media-tabs" role="tablist" aria-label="Media type">
      <button
        role="tab"
        aria-selected={activeTab === 'photos'}
        aria-controls="panel-photos"
        id="tab-photos"
        className={activeTab === 'photos' ? 'active' : ''}
        onClick={() => onChange('photos')}
      >
        <span aria-hidden="true">📷</span>
        <span>Photos</span>
        {photoCount > 0 && <span className="media-tabs-count">{photoCount}</span>}
      </button>
      <button
        role="tab"
        aria-selected={activeTab === 'videos'}
        aria-controls="panel-videos"
        id="tab-videos"
        className={activeTab === 'videos' ? 'active' : ''}
        onClick={() => onChange('videos')}
      >
        <span aria-hidden="true">🎬</span>
        <span>Videos</span>
        {videoCount > 0 && <span className="media-tabs-count">{videoCount}</span>}
      </button>
    </div>
  );
}